import { Pipe, PipeTransform } from '@angular/core';
import { GetAvailableServiceDetailsResponseTypeDefinition } from './ui-editor/ui-editor.component';

/** Determines if a given field is an array or not */
@Pipe({
    name: 'isArrayField',
    standalone: false
})
export class IsArrayFieldPipe implements PipeTransform {

  transform(value: GetAvailableServiceDetailsResponseTypeDefinition): boolean {
    return value.Type.endsWith('[]') ||
      value.Type.startsWith('IEnumerable') ||
      value.Type.startsWith('List<') ||
      value.Type.startsWith('IList');
  }

}
